import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { ZendeskService } from '@app/api/v1/module-core/zendesk/zendesk.service';
import { ZENDESK_KEY } from '@app/services/integrations/zendesk/zendesk.tokens';

export function provideZendesk(key: string): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: ZENDESK_KEY, useValue: key }, ZendeskService]);
}
